export default __webpack_public_path__ + "static/media/093-chevron-9.d84ddd1c.png";